<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HKF9sU/tc-custom/9780226534268.jpg?1722571270341" alt="This image is the cover for the book Tangled Diagnoses"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tangled Diagnoses
      </h1>
      <p class="bookDescription body article font2">
        <p>Since the late nineteenth century, medicine has sought to foster the birth of healthy children by attending to the bodies of pregnant women, through what we have come to call prenatal care. Women, and not their unborn children, were the initial focus of that medical attention, but prenatal diagnosis in its present form, which couples scrutiny of the fetus with the option to terminate pregnancy, came into being in the early 1970s.<br/><br/><i>Tangled Diagnoses</i> examines the multiple consequences of the widespread diffusion of this medical innovation. Prenatal testing, Ilana Löwy argues, has become mainly a risk-management technology—the goal of which is to prevent inborn impairments, ideally through the development of efficient therapies but in practice mainly through the prevention of the birth of children with such impairments. Using scholarship, interviews, and direct observation in France and Brazil of two groups of professionals who play an especially important role in the production of knowledge about fetal development—fetopathologists and clinical geneticists—to expose the real-life dilemmas prenatal testing creates, this book will be of interest to anyone concerned with the sociopolitical conditions of biomedical innovation, the politics of women’s bodies, disability, and the ethics of modern medicine.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ilana Löwy
      </h2>
      
      <p class="authorDescription body article"><B>Ilana Löwy</B> is an emerita senior researcher at Institut National de la Santé et Recherche Médicale, France.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3311623c